import { createSetter, useSubscribedState } from 'nordic/page/store';

export const useEshopsEnvironment = () => useSubscribedState().isEshopsEnvironment;

export const setEshopsEnvironment = createSetter((state, payload) => {
  state.isEshopsEnvironment = payload;
});
